import { Button, styled } from '@mui/material';
import { TooltipMenuItem } from '~/components/menu-item';

export const BulkActionButton = styled(Button)(({ theme }) => ({
  background: theme.palette.common.white,
  border: `1px solid ${theme.palette.borders.light}`,
  color: theme.palette.text.primary,
  justifyContent: 'space-between',
  fontWeight: 500,
  marginRight: theme.spacing(2),
  width: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginRight: 0,
  },
  '&:hover': {
    background: theme.palette.common.white,
  },
}));

export const BulkActionMenuItem = styled(TooltipMenuItem)(({ theme }) => ({
  width: '200px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));
